<template>
  <div id="app">
    <div class="machine-container">
      <h1 class="page-title">
        <span class="label" @click="() => fartSFX.play()">eGBR v3.1.0</span>
      </h1>
      <Info :active="vending" :type="type" />
    <Buttons v-on:click="buttonPressed" :disabled="vending" />
    </div>
    <font-awesome-icon class="fullscreen-button" :icon="isFullscreen ? 'compress' : 'expand'" @click="toggleFullscreen" />
    <span class="byline">DeltOS</span>
    <note />
  </div>
</template>

<script>
import Info from './components/Info.vue'
import Buttons from './components/Buttons.vue'
import Note from './components/Note.vue'

import { AwardType } from './constants'

import { Howl } from 'howler'

import vendingSFX from './assets/sounds/vending-cut.mp3'
import fartSFX from './assets/sounds/fart.mp3'

export default {
  name: 'app',
  components: {
    Info,
    Buttons,
    Note
  },
  data () {
    return {
      isFullscreen: false,
      vending: false,
      type: AwardType.GOOD_BEER,

      apiResponseTime: 0,

      fartSFX: new Howl({
        src: fartSFX
      }),

      vendingSFX: new Howl({
        src: vendingSFX,
        onend: this.vend
      })

    }
  },
  created () {
    document.addEventListener('contextmenu', event => event.preventDefault())
  },
  methods: {
    buttonPressed (buttonId) {
      this.vending = true
      this.setType()
      this.vendingSFX.play() // See onEnd property of vendingSFX in data.
    },
    vend () {
      setTimeout(() => {
        this.vending = false
      }, 2500)
    },
    setType (chance = Math.random()) {
      const goodBeerRatio = 1 / 4

      if (chance < goodBeerRatio) {
        this.type = AwardType.BETTER_BEER
      } else if (chance > 0.9 && chance < 0.9025) { // 1:250 chance of double
        this.type = AwardType.DOUBLE_BEER
      } else if (chance > 0.91 && chance < 0.915) { // 1:200 chance of Ice
        this.type = AwardType.ICE
      } else {
        this.type = AwardType.GOOD_BEER
      }
    },
    toggleFullscreen () {
      this.$fullscreen.toggle(document.documentElement, {
        wrap: false,
        callback: () => { this.isFullscreen = !this.isFullscreen }
      })
    }
  }
}
</script>

<style lang="scss">

* {
  user-select: none;
}

body {
  background-color: #ddd;
  overflow: hidden;
}

#app {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.page-title {
  position: absolute;
  left: 45px;
  top: 35px;
  margin: 0;
  font-size: 3em;

  .label {
  border: 3px solid #2c3e50;
  border-radius: 30px;
  padding: 10px 20px;
  margin-right: 25px;
  }
}

.machine-container {
  padding-top: 25vh;
}

.fullscreen-button {
  cursor: pointer;
  position: absolute;
  right: 25px;
  bottom: 25px;
}

.byline {
  position: absolute;
  opacity: .5;
  left: 45px;
  font-weight: bold;
  bottom: 25px;
}

//-- Animations
.fade-enter-active {
  transition: opacity .25s linear;
}

.fade-leave-active {
  transition: opacity .15s linear;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
